import { Maybe } from "@figurepos/fgr-lib-backend/lib/types"

export type TreeNode = {
    id: string
    children?: Maybe<TreeNode[]>
}

export const addItemToTree = <T extends TreeNode>(tree: T[], parentId: Maybe<string>, newItem: T): T[] => {
    if (!parentId) {
        return [...tree, newItem]
    }
    return tree.map(node => {
        if (node.id === parentId) {
            return {
                ...node,
                children: [...(node.children ?? []), newItem],
            }
        }

        if (node.children) {
            return {
                ...node,
                children: addItemToTree(node.children, parentId, newItem),
            }
        }

        return node
    })
}

export const updateItemInTree = <T extends TreeNode>(tree: T[], itemId: string, updateFn: (node: T) => T): T[] => {
    return tree.map(node => {
        if (node.id === itemId) {
            return updateFn(node)
        }

        if (node.children) {
            return {
                ...node,
                children: updateItemInTree(node.children, itemId, updateFn),
            }
        }

        return node
    })
}

export const removeItemFromTree = <T extends TreeNode>(tree: T[], itemId: string): T[] => {
    return tree
        .filter(node => node.id !== itemId) // filter this level
        .map(node => (node.children ? { ...node, children: removeItemFromTree(node.children, itemId) } : node))
}
